// any type checked blueice
import { TranslatableString } from './translateble-string.model';

export interface ICity {
    id?: string;
    name?: string;
    translateName?: TranslatableString[];
    country?: Country;
    state?: State;
}
export class City implements ICity {
    constructor(
        public id?: string,
        public name?: string,
        public translateName?: TranslatableString[],
        public country?: Country,
        public state?: State
    ) {
        this.id = id ? id : null;
        this.name = name ? name : '';
        this.translateName = translateName ? translateName : [];
        this.country = country ? country : { id: null };
        this.state = state ? state : null;
    }
}

export interface IState {
    id: string;
    name?: string;
    translateName?: TranslatableString[];
    shortName?: string;
    country?: ICountry;
}
export class State implements IState {
    constructor(
        public id: string,
        public name?: string,
        public translateName?: TranslatableString[],
        public shortName?: string,
        public country?: Country
    ) {
        this.id = id ? id : null;
        this.name = name ? name : '';
        this.translateName = translateName ? translateName : [];
        this.shortName = shortName ? shortName : null;
        this.country = country ? country : { id: null };
    }
}

export interface ICountry {
    id: string;
    code?: string;
    name?: string;
    translateName?: TranslatableString[];
    hasState?: boolean;
}

export class Country implements ICountry {
    constructor(
        public id: string,
        public code?: string,
        public name?: string,
        public translateName?: TranslatableString[],
        public hasState?: boolean
    ) {
        this.id = id ? id : null;
        this.code = code ? code : '';
        this.name = name ? name : '';
        this.translateName = translateName ? translateName : [];
        this.hasState = hasState ? hasState : false;
    }
}

export interface IAddress {
    country?: ICountry;
    state?: IState;
    city?: string;
    postalCode?: string;
    street?: string;
    districtCode?: string;
}

export class Address implements IAddress {
    constructor(
        public country?: ICountry,
        public state?: State,
        public city?: string,
        public postalCode?: string,
        public street?: string,
        public districtCode?: string
    ) {
        this.postalCode = postalCode ? postalCode : '';
        this.street = street ? street : '';
        this.city = city ? city : '';
        this.state = state ? state : { id: null };
        this.country = country ? country : { id: null };
        this.districtCode = districtCode ?? null;
    }
}

export interface IPreRegisterAddress {
    country?: ICountry;
    state?: IState;
    city?: string;
    postalCode?: string;
    street?: string;
}
export class PreRegisterAddress implements IPreRegisterAddress {
    constructor(
        public country?: ICountry,
        public state?: State,
        public city?: string,
        public postalCode?: string,
        public street?: string
    ) {
        this.postalCode = postalCode ? postalCode : '';
        this.street = street ? street : '';
        this.city = city ? city : '';
        this.state = state ? state : { id: null };
        this.country = country ? country : { id: null };
    }
}
